import { LocalizationOptions } from '..';
import { isNotNullOrEmptyString } from '../../shared/utils/functions';
import { EDPCompanyInfo } from '../../stacking-plan.model';
import { CompanyColloquial } from '../colloquials/company-colloquial.class';

export interface CompanyOptions {
  localization: LocalizationOptions;
}

export class CompanyClass {
  companyId: number | number[];
  companyLegalName: string;
  companyTradeName: string;
  ultimateParentCompanyName: string;
  refCbreIndustryCodeDesc: string;
  refIndustryClassificationDesc: string;
  colloquial: CompanyColloquial[];

  private _companyName: string;

  constructor(
    edpCompanyInfo: EDPCompanyInfo,
    protected options: Partial<CompanyOptions> = {}
  ) {
    const {
      company_id,
      party_organization_display_name,
      company_legal_name,
      company_trade_name,
      ultimate_parent_company_name,
      ref_cbre_industry_code_desc,
      ref_industry_classification_desc,
      colloquial,
    } = edpCompanyInfo;
    this.companyId = company_id;
    this._companyName = party_organization_display_name;
    this.companyLegalName = company_legal_name;
    this.companyTradeName = company_trade_name;
    this.ultimateParentCompanyName = ultimate_parent_company_name;
    this.refCbreIndustryCodeDesc = ref_cbre_industry_code_desc;
    this.refIndustryClassificationDesc = ref_industry_classification_desc;
    this.colloquial = CompanyColloquial.fromEDPColloquialArray(colloquial);
  }

  get companyName(): string {
    const localizationOptions = this.options.localization || ({} as LocalizationOptions);
    const { isTurnedOn = false, country, language } = localizationOptions;
    let resultCompanyName = this._companyName;
    if (isTurnedOn) {
      const queriedColloquial = CompanyColloquial.findByCountryAndLanguage(this.colloquial, country, language);
      resultCompanyName =
        queriedColloquial != null && isNotNullOrEmptyString(queriedColloquial.alternativeCompanyName)
          ? queriedColloquial.alternativeCompanyName
          : resultCompanyName;
    }
    return resultCompanyName;
  }

  toEDPCompanyInfo(): EDPCompanyInfo {
    const {
      companyId,
      companyLegalName,
      companyTradeName,
      ultimateParentCompanyName,
      refCbreIndustryCodeDesc,
      refIndustryClassificationDesc,
      colloquial,
    } = this;
    return {
      company_id: companyId,
      company_name: this._companyName,
      party_organization_display_name: this._companyName,
      company_legal_name: companyLegalName,
      company_trade_name: companyTradeName,
      ultimate_parent_company_name: ultimateParentCompanyName,
      ref_cbre_industry_code_desc: refCbreIndustryCodeDesc,
      ref_industry_classification_desc: refIndustryClassificationDesc,
      colloquial: colloquial.map(singleColloquial => singleColloquial.toEDPColloquial()),
    };
  }
}
